import Subscription from "../model/subscription.model";

// Sort the subscriptions based on states.
export function sortSubscriptions(subscriptions: Subscription[] | null | undefined): Subscription[] {
  if (!subscriptions) {
    return [];
  }

  const allowedStates: string[] = ['draft', 'pending', 'active', 'pending_termination', 'inactive', 'cancelled'];

  // Create a copy of the array for sorting
  return [...subscriptions].sort((a: Subscription, b: Subscription) =>
    allowedStates.indexOf(a.state) - allowedStates.indexOf(b.state)
  );
}
